import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'

export class FormEntrySelect extends React.PureComponent {
  static getSelectedOptions(sel) {
    const opts = []
    let opt
    const len = sel.options.length
    for (let i = 0; i < len; i += 1) {
      opt = sel.options[i]

      if (opt.selected) {
        opts.push(opt.value)
      }
    }
    return opts
  }

  onChange(e) {
    e.preventDefault()
    let val = e.target.value
    if (this.props.multiple) {
      val = FormEntrySelect.getSelectedOptions(e.target)
    }
    this.props.onChange(val)
  }

  render() {
    return (
      <div className={midas.formGroup}>
        <label className={midas.formLabel} htmlFor={this.props.fieldName}>
          {this.props.fieldCaption}
        </label>
        <select
          className={midas.formSelect}
          multiple={this.props.multiple}
          defaultValue={this.props.defaultValue}
          onChange={e => this.onChange(e)}
        >
          {this.props.values.map((val, index) => {
            let disabled = null
            if (this.props.disablePlaceHolder === 'true' && index === 0) {
              disabled = { disabled: true }
            }
            return (
              <option key={val} value={val} {...disabled}>
                {this.props.names[index]}
              </option>
            )
          })}
        </select>
      </div>
    )
  }
}

FormEntrySelect.propTypes = {
  fieldName: PropTypes.string.isRequired,
  fieldCaption: PropTypes.string.isRequired,
  names: PropTypes.array.isRequired,
  values: PropTypes.array.isRequired,
  defaultValue: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  disablePlaceHolder: PropTypes.string,
  multiple: PropTypes.bool,
}

FormEntrySelect.defaultProps = {
  disablePlaceHolder: 'false',
  multiple: false,
}
